An optional hirer-provided free-text job reference for the position.
